import React, { useState } from 'react';
import { Typography, Link, Stack, SxProps,Theme } from '@mui/material';

interface ExpandableTextProps {
  text: string;
  variant?: 'body1' | 'body2' | 'caption';
  maxLength?: number;
  fontStyle?: 'normal' | 'italic';
  color?: string;
  sx?: SxProps<Theme>; 
}

const ExpandableText: React.FC<ExpandableTextProps> = ({ 
  text, 
  variant = 'body1',
  maxLength = 500,
  fontStyle = 'normal',
  color='text.primary',
  sx
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate && !isExpanded 
    ? `${text.slice(0, maxLength)}...` 
    : text;

  if (!shouldTruncate) {
    return <Typography variant={variant}  color={color} sx={sx} fontStyle={fontStyle}>{text}</Typography>;
  }

  return (
    <Stack spacing={0.5}>
      <Typography variant={variant} fontStyle={fontStyle} color={color}
        sx={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          ...sx,
        }}>
        {displayText}
      </Typography>
      <Link
        component="button"
        variant="body2"
        onClick={() => setIsExpanded(!isExpanded)}
        fontStyle={fontStyle}
        sx={styles.toggleLink}
      >
        {isExpanded ? 'See less' : 'See more'}
      </Link>
    </Stack>
  );
};

const styles = {
  toggleLink: {
    alignSelf: 'flex-start',
    cursor: 'pointer',
    color: '#2196F3',
    textDecoration: 'underline',
  },
} 

export default React.memo(ExpandableText);